import React from 'react';
import { FiLogOut } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';

import './CardInfoUser.css';

const CardInfoUser = (props) => {
    const {user, logout, ticketsStateSummary} = props

    return (
        <div className='container-fluid'>
            <div className='row' >
                <div className='col'>
                    <h6 style={{fontWeight: "500"}}>{user.name}</h6>
                    <span style={{fontSize: "13px"}}>{`${user.installationId} - ${user.installation}`}</span>
                </div>
                <div className='col-3' style = {{display: "flex", justifyContent: "center", alignItems: "center", float: "right"}}>
                    <p className='textLogOut'>{`Salir `}<FiLogOut onClick={() => logout()}/></p>
                </div>
            </div>
            <hr size = "4px" style={{margin:"8px 0px"}} />
            <div className='row'>
                <div className='col-1' style={{marginRight: "5px"}}>
                    <span className = 'badge text-bg-danger' style={{width: "30px"}}>{ticketsStateSummary.pending}</span>
                </div>
                <div className='col-2' style={{marginLeft: "8px"}}>
                    <span>Pendiente</span>
                </div>
            </div>
            <div className='row'>
                <div className='col-1' style={{marginRight: "5px"}}>
                    <span className = 'badge text-bg-warning' style={{width: "30px"}}>{ticketsStateSummary.process}</span>
                </div>
                <div className='col-2' style={{marginLeft: "8px"}}>
                    <span>Proceso</span>
                </div>
            </div>
        </div>
    );
}

export default CardInfoUser;